import { useAsyncQueuer } from "@tanstack/react-pacer"
import { useEffect, useState } from "react"
import { multi_domain_search_emails_search_index_path } from "~/lib/routes"
import { ResultType } from "~/react/components/multi_domain_search/result"

export const useEmailsLoading = (initialEmailIds: number[], setResults: (results: ResultType[]) => void) => {
  const [isLoading, setIsLoading] = useState(false)

  const fetchEmailsFn = async (emailIds: number[]) => {
    const response = await fetch(
      multi_domain_search_emails_search_index_path(),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")
            ?.content,
        },
        body: JSON.stringify({ email_ids: emailIds }),
      },
    )
    const data = await response.json()

    setResults((prev) => {
      const existingIds = new Set(prev.map((result) => result.id))
      const newResults = data.emails.filter(
        (email) => !existingIds.has(email.id),
      )
      return [...prev, ...newResults]
    })
    if (queue.peekPendingItems().length === 0) {
      setIsLoading(false)
    }
  }
  const queue = useAsyncQueuer(fetchEmailsFn, { concurrency: 10, wait: 10 })

  useEffect(() => {
    if (initialEmailIds.length > 0) {
      setIsLoading(true)
      const batchSize = 5000
      for (let i = 0; i < initialEmailIds.length; i += batchSize) {
        queue.addItem(initialEmailIds.slice(i, i + batchSize))
      }
    }
  }, [initialEmailIds])

  return { queue, isLoading }
}
